import React, { useEffect, useMemo, useState } from 'react';
import { Container, Stack, Grid, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// react icons
import { FaRegUser } from 'react-icons/fa';
import { GiMoneyStack, GiTakeMyMoney } from 'react-icons/gi';

// material icons
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventNoteIcon from '@mui/icons-material/EventNote';

import { NOT_AVAILABLE } from '../Global/Constants';
// componenets
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import { getNetworkViewList } from '../../store/Slice/Payout/PayoutSlice';
import ViewCardComponent from '../../components/ViewCards';
import { normalizeValue } from '../../utils/CommonFunction';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';

export default function ViewNetwork() {
  const location = useLocation();
  const { rowId } = location?.state || {};
  const dispatch = useDispatch();
  const { NetworkViewData } = usePayoutSelector();

  useEffect(() => {
    const fetchNetworkDetails = async () => {
      if (rowId?.id && rowId?.type) {
        dispatch(getNetworkViewList(rowId.id, rowId.type));
      }
    };
    fetchNetworkDetails();
  }, [rowId, dispatch]);

  const networkFields = useMemo(
    () => [
      {
        label: 'Identifier',
        value: normalizeValue(NetworkViewData?.identifier, NOT_AVAILABLE),
        icon: <EventNoteIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Name',
        value: normalizeValue(NetworkViewData?.name, NOT_AVAILABLE),
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'Type',
        value: normalizeValue(NetworkViewData?.type, NOT_AVAILABLE),
        icon: <AdUnitsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Status',
        value: normalizeValue(NetworkViewData?.status, NOT_AVAILABLE),
        icon: <EventNoteIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Reporting Manager',
        value: normalizeValue(NetworkViewData?.reportingManagerName, NOT_AVAILABLE),
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'Sales Manager',
        value: normalizeValue(NetworkViewData?.salesManagerName, NOT_AVAILABLE),
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'Years Of Relationship',
        value: normalizeValue(NetworkViewData?.yearsOfRelationship, NOT_AVAILABLE),
        icon: <CalendarTodayIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Created On',
        value: normalizeValue(NetworkViewData?.createdOn, NOT_AVAILABLE),
        icon: <CalendarTodayIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'Credit Limit',
        value: normalizeValue(NetworkViewData?.creditLimit, NOT_AVAILABLE),
        icon: <GiTakeMyMoney className="viewLabelIcon" size={24} />
      },
      {
        label: 'Net Sales YTD',
        value: normalizeValue(NetworkViewData?.netSalesYTD, NOT_AVAILABLE),
        icon: <GiMoneyStack className="viewLabelIcon" size={24} />
      }
    ],
    [NetworkViewData]
  );

  return (
    <Page title="Partner Management System || Network Details">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="View File" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Grid container spacing={3} mt={1}>
            <ViewCardComponent title="Profile Information" fields={networkFields} />
          </Grid>
        </Box>
      </Container>
    </Page>
  );
}
